/* eslint-disable */
/**
 * Accessory Gate + Free Bundle
 * ----------------------------
 * Scope 1: Accessories cannot be purchased without a bike in cart.
 * Scope 2: Buy a coloured XE Pro S or any Altis Sigma MX -> auto-add all 8 fixed
 *          accessories, incl. the Universal paddock stand (2026-08-31:
 *          the Spool/Universal picker was removed — JP call, it confused
 *          customers; Universal fits any swingarm so it's the safe
 *          default). Total bundle value $554.65, zeroed by a Shopify
 *          Automatic BXGY discount.
 *
 * Bake-in variant IDs (Globalbike.co Shopify, captured 2026-05-15).
 * If a bike or accessory variant ID changes, update the lists below.
 */
(function () {
  'use strict';

  // Qualifying set (JP 2026-10-02): coloured XE Pro S + Altis Sigma MX ONLY.
  // XF Pro (Enduro/Super), Delta, legacy Sigma and E·XE 880 no longer get the kit.
  // Must match the BXGY discount 1711807987937 'customerBuys' products exactly.
  var QUAL_BIKES = [
    47978422436065, 47978422468833, 47978422501601, 48168430043361, // XE Pro S Green/Pink/White/Grey (Black does NOT qualify)
    47858399609057, 47858399641825                                   // Altis Sigma MX Black/Red (any colour qualifies)
  ];

  // 8 fixed accessory variant IDs (auto-added on coloured-bike entry).
  // Was 7 auto-added + a Spool/Universal picker for the 8th; picker removed
  // 2026-08-31, Universal now auto-adds with the rest (see header note).
  var FREE_FIXED = [
    48370921636065, // 5. Dirt Bike Stand
    48370921668833, // 3. Motorbike Stand
    48370921701601, // 8. Tie Downs
    48370922225889, // 1. Heavy-Duty Loading Ramp
    48370922488033, // 4. Front Wheel Stand
    48370922553569, // 9. Chain Brush - Red
    48370922717409, // 10. Chain Tool
    48370923110625  // 7. Rear Paddock Stand - Universal
  ];

  // Not part of the free kit. Spool Mount (48370922979553) is still sold as
  // a standalone product for customers who specifically want it (requires
  // M8/M10 swingarm spools); it's simply no longer offered inside the
  // bundle. Folding Loading Ramp (48370922160353) was never in the bundle.

  var ACC_HANDLES = [
    'dirt-bike-stand', 'motorbike-stand', 'tie-downs',
    'folding-loading-ramp', 'heavy-duty-loading-ramp', 'front-wheel-stand',
    'chain-brush', 'chain-tool',
    'rear-paddock-stand-spool', 'rear-paddock-stand-universal'
  ];
  var NON_BIKE_TYPES = ['Accessories', 'Merch', 'Service', 'Spare Parts', 'Gift Card'];

  var refreshing = false;
  var refreshQueued = false;

  async function getCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }
  function hasBike(cart)            { return cart.items.some(function (it) { return it.product_type && NON_BIKE_TYPES.indexOf(it.product_type) === -1; }); }
  function hasQualifyingBike(cart)  { return cart.items.some(function (it) { return QUAL_BIKES.indexOf(it.variant_id) !== -1; }); }
  function missingFixed(cart) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id] = true; });
    return FREE_FIXED.filter(function (id) { return !inCart[id]; });
  }
  function bundleLinesToStrip(cart) {
    if (hasQualifyingBike(cart)) return [];
    return cart.items.filter(function (it) { return it.properties && it.properties._free_bundle === '1'; });
  }

  // Enforce one-of-each on the free kit.
  // Two rapid Add-to-Cart clicks can interleave two add cycles and leave the
  // kit at quantity 2. That is not cosmetic: the BXGY discount covers exactly
  // 8 units, so every duplicate falls OUTSIDE it and bills at FULL LIST price
  // (measured 2026-07-27: a doubled kit charged the customer $265.10).
  // Only lines carrying _free_bundle are touched — a customer who deliberately
  // buys a second chain brush has no such property and is never modified.
  function bundleLinesToNormalise(cart) {
    var seen = {};
    var updates = {};
    cart.items.forEach(function (it) {
      if (!(it.properties && it.properties._free_bundle === '1')) return;
      if (seen[it.variant_id]) { updates[it.key] = 0; return; } // duplicate LINE -> remove
      seen[it.variant_id] = true;
      if (it.quantity !== 1) updates[it.key] = 1;               // over-added   -> back to 1
    });
    return updates;
  }

  // Dawn-style cart section IDs to re-render after cart mutations
  var CART_SECTIONS = 'cart-drawer,cart-icon-bubble,cart-live-region-text,main-cart-items,main-cart-footer';

  async function bulkAdd(items) {
    if (!items.length) return;
    var res = await fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: CART_SECTIONS, sections_url: window.location.pathname }),
    });
    var json = await res.json().catch(function () { return {}; });
    paintCartSections(json.sections);
    return json;
  }
  async function bulkUpdate(updates) {
    var res = await fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: CART_SECTIONS, sections_url: window.location.pathname }),
    });
    var json = await res.json().catch(function () { return {}; });
    paintCartSections(json.sections);
    return json;
  }

  // Apply Shopify-returned section HTML to update Dawn's cart drawer + icon bubble.
  // Uses Dawn's own renderContents() method which repaints the drawer + auto-opens it
  // so the customer sees the auto-added bundle items land in real time.
  function paintCartSections(sections) {
    if (!sections) return;

    // Preferred path: call Dawn's cart-drawer.renderContents() — handles full
    // repaint, classlist toggles, and drawer-open in one call.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents({ sections: sections, id: 'acc-gate' });
        return;
      } catch (e) { /* fall through to manual DOM swap */ }
    }

    // Fallback: manual section innerHTML swap for themes / pages without cart-drawer.
    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newRoot = doc.querySelector('#shopify-section-' + sectionId) || doc.body.firstElementChild;
      if (!newRoot) return;
      var live = document.querySelector('#shopify-section-' + sectionId);
      if (live) {
        live.innerHTML = newRoot.innerHTML;
      } else {
        var liveAlt = document.querySelector('[id^="shopify-section-"][id*="' + sectionId + '"]');
        if (liveAlt) liveAlt.innerHTML = newRoot.innerHTML;
      }
    });

    // Tell other listeners
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'accessory-gate' }); } catch (e) {}
    }
  }

  // ---------- DOM helpers (safe, no innerHTML) ----------
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'style') node.style.cssText = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (k === 'on') Object.keys(attrs.on).forEach(function (ev) { node.addEventListener(ev, attrs.on[ev]); });
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  // ---------- Accessory PDP gate ----------
  function gateAccessoryPDP(hasBikeNow) {
    var path = window.location.pathname.replace(/\/$/, '');
    var isAcc = ACC_HANDLES.some(function (h) { return path === '/products/' + h; });
    if (!isAcc) return;

    var forms = document.querySelectorAll('product-form, form[action*="cart/add"]');
    var existing = document.getElementById('acc-gate-pdp');

    if (!hasBikeNow) {
      if (!existing) {
        var headline = el('p', {
          style: 'background:rgb(0 0 0);color:rgb(255 230 0);padding:14px 18px;border:1px solid rgba(255,230,0,0.5);border-radius:8px;font-family:Oswald,sans-serif;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;font-size:0.82rem;text-align:center;margin:0;',
          text: 'Accessories unlock with any bike in cart'
        });
        var bodyP = el('p', {
          style: 'background:rgb(15 15 15);color:rgb(255 255 255 / 0.88);padding:16px 18px;border:1px solid rgba(255,255,255,0.1);border-radius:8px;margin:8px 0 0;text-align:center;font-size:0.92rem;line-height:1.5;'
        });
        bodyP.appendChild(document.createTextNode('Add any '));
        var link = el('a', { href: '/collections/all', style: 'color:rgb(255 230 0);font-weight:600;text-decoration:underline;text-underline-offset:3px;', text: 'Globalbike.co e-bike' });
        bodyP.appendChild(link);
        bodyP.appendChild(document.createTextNode(' to your cart and your accessory cart unlocks. '));
        var em = el('strong', { style: 'color:rgb(255 230 0);', text: 'Pick a coloured XE Pro or XF Pro' });
        bodyP.appendChild(em);
        bodyP.appendChild(document.createTextNode(' and a $554 accessory kit lands free.'));

        var wrap = el('div', { id: 'acc-gate-pdp', style: 'margin:20px 0;' }, [headline, bodyP]);
        if (forms[0] && forms[0].parentNode) forms[0].parentNode.insertBefore(wrap, forms[0]);
      }
      forms.forEach(function (f) { f.style.display = 'none'; });
    } else {
      if (existing) existing.remove();
      forms.forEach(function (f) { f.style.display = ''; });
    }
  }

  // ---------- /pages/gear button gate ----------
  function gateGearPage(hasBikeNow) {
    var p = window.location.pathname.replace(/\/$/, '');
    if (p !== '/pages/gear-shop' && p !== '/pages/gear') return;
    var buttons = document.querySelectorAll('.ac-btn[href^="/products/"]');
    buttons.forEach(function (b) {
      var href = b.getAttribute('href') || '';
      var isAcc = ACC_HANDLES.some(function (h) { return href.indexOf('/products/' + h) === 0; });
      if (!isAcc) return;
      if (!b.dataset.originalText) b.dataset.originalText = b.textContent.trim();
      if (!hasBikeNow) {
        b.textContent = 'Add a bike to unlock';
        b.style.opacity = '0.6';
        b.style.pointerEvents = 'none';
        b.setAttribute('aria-disabled', 'true');
      } else {
        b.textContent = b.dataset.originalText;
        b.style.opacity = '';
        b.style.pointerEvents = '';
        b.removeAttribute('aria-disabled');
      }
    });
  }

  function paintGearBanners(hasBikeNow, qualNow) {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/gear-shop'
        && window.location.pathname.replace(/\/$/, '') !== '/pages/gear') return;
    var noBike   = document.querySelector('[data-acc-state="no-bike"]');
    var qual     = document.querySelector('[data-acc-state="has-qual-bike"]');
    var nonQual  = document.querySelector('[data-acc-state="has-bike-not-qual"]');
    if (noBike)  noBike.style.display  = hasBikeNow ? 'none' : '';
    if (qual)    qual.style.display    = (hasBikeNow && qualNow) ? '' : 'none';
    if (nonQual) nonQual.style.display = (hasBikeNow && !qualNow) ? '' : 'none';
  }

  // ---------- Main refresh ----------
  async function refresh() {
    // A refresh arriving mid-cycle used to be dropped on the floor, so the
    // cart state that triggered it went unexamined until the 6s poll. Coalesce
    // instead: remember it and run exactly once more when this cycle ends.
    if (refreshing) { refreshQueued = true; return; }
    refreshing = true;
    try {
      var cart = await getCart();

      // Auto-add missing FIXED accessories when coloured bike present
      if (hasQualifyingBike(cart)) {
        var missing = missingFixed(cart);
        if (missing.length) {
          await bulkAdd(missing.map(function (id) {
            return { id: id, quantity: 1, properties: { _free_bundle: '1' } };
          }));
          cart = await getCart();
        }
      }

      // Self-heal any duplication before it can reach checkout
      var fixes = bundleLinesToNormalise(cart);
      if (Object.keys(fixes).length) {
        await bulkUpdate(fixes);
        cart = await getCart();
      }

      // Strip bundle items if qualifying bike no longer present
      var stale = bundleLinesToStrip(cart);
      if (stale.length) {
        var updates = {};
        stale.forEach(function (l) { updates[l.key] = 0; });
        await bulkUpdate(updates);
        cart = await getCart();
      }

      var bikeNow = hasBike(cart);
      var qualNow = hasQualifyingBike(cart);
      gateAccessoryPDP(bikeNow);
      gateGearPage(bikeNow);
      paintGearBanners(bikeNow, qualNow);

      document.dispatchEvent(new CustomEvent('accessory-gate:refreshed', {
        detail: { hasBike: bikeNow, hasQualifyingBike: qualNow, cart: cart }
      }));
    } catch (e) {
      console.warn('[acc-gate]', e);
    } finally {
      refreshing = false;
      if (refreshQueued) { refreshQueued = false; setTimeout(refresh, 50); }
    }
  }

  // Intercept cart-mutating fetches
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mut = /\/cart\/(add|update|change|clear)/.test(url);
    var p = origFetch.call(this, input, init);
    if (mut) p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  setInterval(refresh, 6000);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:updated', refresh);
  window.addEventListener('focus', refresh);
})();
